// SQP-302 Shell step 1: pure nav model for the desktop sidebar (docs/DASHBOARD-DESIGN.md section 6).
// No React import so plain node can load it (tests/dashboard-nav.test.js).
//
// A section is { id, label, to?, end?, count?, children? }. `to: null` makes the section a plain group
// heading (Requests): only its children navigate. `count` names a key of the counts object the layout
// passes in; a section with no own `count` shows the sum of its children's counts.
// Step 1 keeps Trips and Intake as separate routes; a later step merges them behind a segmented control.

export const NAV_SECTIONS = [
  {
    id: 'live', label: 'Live', to: '/', end: true,
    children: [{ id: 'batches', label: 'Batches', to: '/batches' }],
  },
  {
    id: 'requests', label: 'Requests', to: null,
    children: [
      { id: 'trips', label: 'Trips', to: '/trips' },
      { id: 'intake', label: 'Intake', to: '/centralized-requests', count: 'heldIntake' },
    ],
  },
  { id: 'review', label: 'Review', to: '/trs' },
  { id: 'alerts', label: 'Alerts', to: '/anomalies' },
  { id: 'config', label: 'Config', to: '/config' },
];

function matches(row, pathname) {
  if (!row.to) return false;
  if (row.end) return pathname === row.to;
  return pathname === row.to || pathname.startsWith(row.to + '/');
}

// Which section / row is active for a pathname. Layout.jsx lights rows from this (single source of
// truth). Live is exact-match (end) so `/` never claims another route; /batches resolves to the
// Batches row, /trips/ID to Trips (prefix match on a path segment).
// -> { section: id, row: id } | null
export function activeNav(pathname) {
  // react-router 6 matches case-insensitively, so the lit row must too (/TRIPS renders Trips).
  const p = (pathname || '').toLowerCase().replace(/\/+$/, '') || '/';
  for (const s of NAV_SECTIONS) {
    for (const c of s.children || []) if (matches(c, p)) return { section: s.id, row: c.id };
    if (matches(s, p)) return { section: s.id, row: s.id };
  }
  return null;
}

// Badge number for a row or section: own count if declared, else the sum of its children's.
export function navCount(item, counts = {}) {
  if (item.count) return counts[item.count] || 0;
  return (item.children || []).reduce((n, c) => n + navCount(c, counts), 0);
}
